import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import { useMemo } from 'react';
import 'prop-types';
import { jsx } from '@emotion/core';
import merge from 'deepmerge';
import { heading1 } from '../../styles/typography/heading1.js';
import { heading2 } from '../../styles/typography/heading2.js';
import { heading3 } from '../../styles/typography/heading3.js';
import { heading4 } from '../../styles/typography/heading4.js';
import { heading4G } from '../../styles/typography/heading4G.js';
import { heading5 } from '../../styles/typography/heading5.js';
import { heading5G } from '../../styles/typography/heading5G.js';
import { heading6 } from '../../styles/typography/heading6.js';
import { heading6G } from '../../styles/typography/heading6G.js';
import { heading7G } from '../../styles/typography/heading7G.js';

function Heading(_ref) {
  var level = _ref.level,
      headingStyle = _ref.headingStyle,
      children = _ref.children,
      theme = _ref.theme,
      otherProps = _objectWithoutProperties(_ref, ["level", "headingStyle", "children", "theme"]);

  var HeadingLevel = "h".concat(level);
  var styleObj = useMemo(function () {
    var results = heading4;

    if (headingStyle) {
      switch (headingStyle.toLowerCase()) {
        case 'heading7g':
          results = heading7G;
          break;

        case 'heading6g':
          results = heading6G;
          break;

        case 'heading6':
          results = heading6;
          break;

        case 'heading5g':
          results = heading5G;
          break;

        case 'heading5':
          results = heading5;
          break;

        case 'heading4g':
          results = heading4G;
          break;

        case 'heading4':
          results = heading4;
          break;

        case 'heading3':
          results = heading3;
          break;

        case 'heading2':
          results = heading2;
          break;

        default:
          results = heading1;
      }
    }

    return merge.all([results, theme]);
  }, [headingStyle, theme]);
  return jsx(HeadingLevel, _extends({
    css: styleObj
  }, otherProps), children);
}

Heading.defaultProps = {
  children: '',
  theme: {},
  headingStyle: undefined
};

export default Heading;
